import View     from 'scripts/poppet/view';
import template from 'templates/zoneMenuView.jst.html';
import { Vue }  from 'vue/defavue';

/**
 * defa.views.ZoneMenuView
 * A description.
 * @version 0.1
 */

const selectors = {
	menuItems : '[data-click^=nav-]',
	preset    : '[data-click=nav-preset]',
	manual    : '[data-click=nav-manual]',
	lockZone  : '[data-input=lock-zone-switch]'
};

const ZoneMenuView = View.extend({
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	tagName   : 'nav',
	className : 'module-menu',
	template  : template,
	
	ui: {
		menuItems : selectors.menuItems,
		preset    : selectors.preset,
		manual    : selectors.manual,
		lockZone  : selectors.lockZone,
	},
	
	events: {
		'click @ui.menuItems' : 'onClickMenuItems',
		'click @ui.lockZone'  : 'onClickLockZone',
	},
	
	modelEvents: {
		'change' : 'onModelChange',
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	onModelChange: function(){
		if(this.model.isComplete()){
			this.render();
		}
	},
	onRender: function(){
		if(!this.options.settingsHome.get('zone'+this.model.get('zoneNumber')).enabled){
			this.diableZoneCommunicationElements();
		}
		if(!this.model.isThermostatOrRegulator()){
			this.hideElement('preset');
			this.hideElement('manual');
		}
		this.ui.lockZone.prop('checked', !this.options.settingsHome.get('zone'+this.model.get('zoneNumber')).enabled);
	},
	
	onDomRefresh: function(){
		let self   = this;
		new Vue ({
			el: '#zone-follow-main-vue',
			
			bb() {
				return {
					model: self.model.getModel('5')
				};
			},
			
			data() {
				return {
					followMasterValue: false,
					locked: false
				}
			},
			methods : {
				save() {
					let data = {};
					data.followMaster = this.followMasterValue;
					self.saveModel('5',  data )
				},
			},
			
			computed: {
				disableFollowMaster: function () {
					return this.locked || null === this.model.followMaster
				},
				modelError: function () {
					return this.model.modelError
				},
				attributeError: function () {
					return this.model.followMasterError
				}
				
			},
			
			watch : {
				'model.followMaster' : function (newValue){
					this.followMasterValue = !!newValue;
				}
			},
			
			created () {
				this.followMasterValue = !!this.model.followMaster;
				this.locked = !self.options.enabled
			}
		});
		
		
	},
	
	onClickMenuItems: function( event ) {
		event.preventDefault();
		
		let $target = $( event.target ).closest( selectors.menuItems ),
			command = $target.attr( 'data-click' ).replace( 'nav-', '' );
		
		this.trigger( 'nav', command );
	},
	
	/**
	 * Triggers wen the Lock zone is clicked.
	 * @void
	 */
	onClickLockZone: function(){
		let locked = this.ui.lockZone.is(':checked');
		if(locked === this.options.settingsHome.get('zone'+this.model.get('zoneNumber')).enabled){
			let zone = {
				enabled : !locked,
				id : this.options.settingsHome.get('zone'+this.model.get('zoneNumber')).id || null,
				temperatureAlias: this.options.settingsHome.get('zone'+this.model.get('zoneNumber')).temperatureAlias || '',
				zoneAlias : this.options.settingsHome.get('zone'+this.model.get('zoneNumber')).zoneAlias || '',
			};
			this.options.settingsHome.saveZone(zone, this.model.get('zoneNumber'));
		}
		this.trigger('update:lock', this);
		this.render();
		
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	saveModel: function (model, attrs) {
		let self = this;
		self.busy();
		try {
			self.model.getModel(model).save( attrs, {
				patch: true,
				isSaving: true,
				success: function () {
					console.log( 'Model was saved!' );
					self.idle();
				},
				error  : function () {
					console.error( 'Model failed at saving...' );
					self.idle();
				}
			} );
		} catch ( err ) {
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
		}
	},
	
	diableZoneCommunicationElements: function(){
		this.$('.disable').attr('disabled', true)
	},
});

// attach to global space
export default ZoneMenuView;
